module.exports = __webpack_public_path__ + "img/ANTENNA TWIRL GREEN.c6c4162.svg";